<list-view *ngIf="listeZonesPredefinies" [liste]="listeZonesPredefinies"></list-view>
